export const START_YEAR = 2017;
export const RASIO_KEUANGAN = "RASIO_KEUANGAN";
export const RASIO_KEUANGAN_SINGLE = "RASIO_KEUANGAN_SINGLE";
export const RASIO_KEUANGAN_YEAR = "RASIO_KEUANGAN_YEAR";
export const RASIO_KEUANGAN_KUARTAL = "RASIO_KEUANGAN_KUARTAL";
export const COMPANY_TYPES = [
  { value: 1, label: "Lembaga Keuangan" },
  { value: 2, label: "Non Lembaga Keuangan" },
];

// local fakhrul
// export const IMG_PATH = "http://localhost/bumd-images";
// prod
export const IMG_PATH = "https://bumdjuara.jabarprov.go.id/img";

export const MONTHS = [
  "Januari",
  "Februari",
  "Maret",
  "April",
  "Mei",
  "Juni",
  "Juli",
  "Agustus",
  "September",
  "Oktober",
  "November",
  "Desember",
];
export const COLORS = [
  "#388E3C",
  "#43A047",
  "#66BB6A",
  "#DAF7A6",
  "#FDD835",
  "#FFC300",
  "#FF5733",
  "#339e99",
  "#900C3F",
  "#5E35B1",
  "#9C27B0",
  "#455A64",
  "#6D4C41",
  "#F57C00",
  "#009688",
];
export * from "./actionType";
export * from "./api";
export * from "./chart";
